import React from 'react';
import { FormControlLabel, TextField, InputAdornment, IconButton } from '@mui/material';
import CloseButton from '@/components/UI/CloseButton/CloseButton';
import { AFF_VEHICLES } from '@/helpers/constants';
import { ExecutiveSummaryPreferences } from '@/types';
import styles from './DialogSummary.module.scss';

interface InputTextSummaryProps {
  id: string;
  label: string;
  value: ExecutiveSummaryPreferences;
  className?: string;
  add?: boolean;
  clearList?: boolean;
  deleteList?: (value: ExecutiveSummaryPreferences) => void;
  addList?: (value: ExecutiveSummaryPreferences) => void;
}

const SUMMARY_INPUTS = {
  BLOCKING_RECOMMENDATION: 'blockingRecommendation',
  NO_OF_AFF_PLANTS_AND_MODELS: 'numberOfAffectedPlantsAndModels',
  ESTIMATED_NOK_RATE: 'estimatedNOKRate',
  VEHICLE_VOLUME_NUMBERS: 'vehicleVolumeNumbers',
};

const InputTextSummary: React.FC<InputTextSummaryProps> = (props) => {
  const { id, label, value, className, add = false, clearList = false, deleteList = () => null, addList = () => null } = props;
  const inputLabel = label;

  const handleDelete = () => {
    deleteList(value);
  };

  const handleAdd = () => {
    addList(value);
  };

  const formatValue = (valueToFormat: ExecutiveSummaryPreferences) => {
    if (valueToFormat === SUMMARY_INPUTS.BLOCKING_RECOMMENDATION) {
      return '[YES/NO]';
    }

    if (valueToFormat === AFF_VEHICLES.AMG) {
      return '[YES/NO]';
    }

    if (valueToFormat === SUMMARY_INPUTS.NO_OF_AFF_PLANTS_AND_MODELS) {
      return '[NUMBER | NUMBER]';
    }

    if ([SUMMARY_INPUTS.ESTIMATED_NOK_RATE, SUMMARY_INPUTS.VEHICLE_VOLUME_NUMBERS].includes(valueToFormat)) {
      return '[NUMBER]';
    }

    return 'Value';
  };

  return (
    <FormControlLabel
      label={undefined}
      className={`${styles.FormLabelWrapper} ${styles.InputSize} ${className} ${styles.FormLabel}`}
      control={(
        <TextField
          variant="outlined"
          InputProps={{
            endAdornment: (add || clearList) && (
              <>
                <InputAdornment position="end">
                  {clearList && (
                    <CloseButton closeStyle={styles.IconClear} onClick={handleDelete} />
                  )}
                </InputAdornment>
                {add && (
                  <InputAdornment position="end">
                    <IconButton
                      className={`di icon-plus-hinzufuegen-klein ${styles.CardIco}`}
                      color="inherit"
                      size="small"
                      aria-label="clear"
                      onClick={handleAdd}
                    />
                  </InputAdornment>
                )}
              </>
            ),
          }}
          InputLabelProps={{ shrink: true }}
          disabled
          id={id}
          label={inputLabel}
          value={formatValue(value)}
          fullWidth
        />
      )}
    />
  );
};

export default InputTextSummary;
